<template>
  <div class="content-container payment-options">
    <div class="content h-auto">
      <div class="container">
        <div class="row" v-if="booking && booking.is_from_pre_booking">
          <!-- Basket -->
          <div class="col-12">
            <div class="title">
              <h1>Your basket</h1>
            </div>
          </div>

          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <basket-item
                    v-for="(device, key) in devices"
                    :key="key"
                    :device-data="device"
                    :device-key="key"
                    hideControls>
                </basket-item>
              </div>
            </div>
          </div>
        </div>

        <!-- Billing address and payment data -->
        <empty-state v-if="isStillLoading"
                     class="overlay fullscreen"
                     statusIcon="loading"
                     :title="$t('bp.loading')"
                     :subtitle="$t('bp.pleaseWait')"
        ></empty-state>

        <div class="row" v-if="!isStillLoading">

          <!-- Title -->
          <div class="col-12">
            <div class="title mt-5">
              <h1>{{$t('bp.PaymentOptions.title')}}</h1>
            </div>
          </div>

          <!-- Billing Address -->
          <div class="col-12">
            <div class="card card-body">
              <template v-if="!chosenDropOffStoreId">
                <label>{{$t('bp.PaymentOptions.confirmTitle')}} <span class="text-danger">*</span></label>
                <p class="text-danger text-sm font-weight-bold">{{$t('bp.PaymentOptions.confirmText')}}</p>
                <div class="row form-inline">
                  <div class="col-md-6">
                    <label class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" value="use-repair-address"
                             v-model="billingAddress" @click="billingAddressFormShown = false">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">{{
                          parseAddressToString(booking.billing_address)
                        }}</span>
                    </label>
                  </div>
                  <div class="col-md-6">
                    <label class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" value="new-billing-address"
                             v-model="billingAddress" @click="setManualBillingAddress()">
                      <!--                                            <input type="radio" class="custom-control-input" value="new-billing-address" v-model="billingAddress" @click="billingAddressFormShown = true">-->
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-description">{{$t('bp.PaymentOptions.differentAddressButton')}}</span>
                    </label>
                  </div>
                </div>
              </template>
              <template v-if="chosenDropOffStoreId && !billingAddressFormShown">
                <span class="custom-control-description mb-4">{{ parseAddressToString(booking.billing_address) }}</span>
                <button @click="billingAddressFormShown = true" class="btn btn-success btn-lg">Change Billing Address
                </button>
              </template>
              <div id="billing-address-form" class="collapse" :class="{ 'show': billingAddressFormShown }">
                <div class="collapse-body p-0">
                  <hr v-if="!chosenDropOffStoreId"/>
                  <div class="collapse-content">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('bp.CustomerDetails.firstName')}} <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="newFirstName">
                          <input-error :errors="billingAddressFormErrors['billing_first_name']"></input-error>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>{{$t('bp.CustomerDetails.lastName')}} <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="newLastName">
                          <input-error :errors="billingAddressFormErrors['billing_last_name']"></input-error>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label>{{$t('bp.PaymentOptions.billing.address.line1')}} <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="newBillingAddress.line_1">
                          <input-error :errors="billingAddressFormErrors['billing_address.line_1']"></input-error>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label>{{$t('bp.PaymentOptions.billing.address.line2')}}</label>
                          <input type="text" class="form-control" v-model="newBillingAddress.line_2">
                          <input-error :errors="billingAddressFormErrors['billing_address.line_2']"></input-error>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label>{{$t('bp.PaymentOptions.billing.city')}} <span class="text-danger">*</span></label>
                          <input type="text" class="form-control" v-model="newBillingAddress.town">
                          <input-error :errors="billingAddressFormErrors['billing_address.town']"></input-error>
                        </div>
                      </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="">
                                        <label>{{$t('bp.PaymentOptions.billing.postcode')}} <span class="text-danger">*</span></label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="">
                                        <label>{{$t('bp.PaymentOptions.billing.country')}} <span class="text-danger">*</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="newBillingAddress.postcode">
                                        <input-error :errors="billingAddressFormErrors['billing_address.postcode']"></input-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <v-select :options="this.countrySelect" v-model="selectedCountry" v-bind:key="this.countrySelect.label"
                                                  v-bind:value="this.countrySelect.value">
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button v-if="!savingBillingAddress" @click="saveNewBillingInformation()"
                            class="btn btn-success btn-lg" :disabled="!canSaveNewBillingAddress">{{$t('bp.PaymentOptions.address.save')}}
                    </button>
                    <button v-if="savingBillingAddress" class="btn btn-success btn-lg" disabled>Saving Billing
                      Address...
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Title -->
          <div class="col-12">
            <div class="title mt-5">
              <h1>{{$t('bp.PaymentOptions.title2')}}</h1>
            </div>
          </div>

          <!-- Payment Options List -->
          <div class="col-12">
            <div class="card-list position-relative h-auto">
              <empty-state
                  v-if="billingAddressFormShown"
                  icon="home"
                  iconSize="xl"
                  overlay
                  :title="$t('bp.PaymentOptions.empty.title')"
                  :content="$t('bp.PaymentOptions.empty.text')"
              ></empty-state>

              <template v-show="!billingAddressFormShown">
                <!-- Klarna -->
                <klarna-payment-method @iwOrderIsOow="iwOrderIsOow()" v-if="klarnaInstalled"></klarna-payment-method>

                <!-- Klarna Instalments -->
                <klarna-instalments-payment-method @iwOrderIsOow="iwOrderIsOow()"
                                                   v-if="klarnaInstalled"></klarna-instalments-payment-method>

                <!-- Braintree - Debit/Credit Card/PayPal -->
                <drop-in-3d-secure @iwOrderIsOow="iwOrderIsOow()" v-if="carrierDetails.use3DSecure"
                                   :is-selected="true"></drop-in-3d-secure>

                <drop-in @iwOrderIsOow="iwOrderIsOow()" v-if="!carrierDetails.use3DSecure"
                         :is-selected="true"></drop-in>
              </template>
            </div>
          </div>
        </div>

        <!-- Payment error modal -->
        <payment-error-modal></payment-error-modal>

        <!-- Out of Warranty Modal -->
        <out-of-warranty-modal></out-of-warranty-modal>

      </div>
    </div>
  </div>
</template>


<script>
/* global Klarna */
import {mapActions, mapGetters} from "vuex";
import "vue-select/dist/vue-select.css";

let VueScrollTo = require('vue-scrollto');

export default {
  name: "PaymentOptions",

  data() {
    return {
      billingAddress: "use-repair-address",
      billingAddressFormShown: false,
      newFirstName: null,
      newLastName: null,
      newBillingAddress: {
        line_1: null,
        line_2: null,
        town: null,
        postcode: null,
      },
      savingBillingAddress: false,
      billingAddressFormErrors: [],
      selectedCountry: null
    }
  },

  mounted() {
    this.checkCanBeOnPage();

    this.selectedCountry = this.countrySelect.find(({value}) => value === this.carrierDetails.countryCodeAlpha2);

    if (!this.klarnaInstalled) {
      this.setPaymentMethod("braintree");
    }

    this.generateBillingTokens().then(() => {
      this.newFirstName = this.booking.first_name;
      this.newLastName = this.booking.last_name;

      if (this.chosenDropOffStoreId) {
        this.billingAddressFormShown = true;
      } else {
        this.newBillingAddress = Object.assign({}, this.booking.billing_address);
      }

      if (this.klarnaInstalled) {
        this.$nextTick(() => {
          this.setupKlarna();
        })
      }
    }).catch(() => {
      this.retrieveBooking().then(() => {
        this.checkCanBeOnPage();
      });
    })
  },

  computed: {
    ...mapGetters([
      "carrier",
      "carrierDetails",
      "devices",
      "booking",
      "inWarrantyStatus",
      "klarnaClientToken",
      "braintreeToken",
      "parseAddressToString",
      "selectedProblems",
      "warrantyRepairChargeable",
      "chosenDropOffStoreId",
      "klarnaInstalled",
      "countrySelect"
    ]),

    canSaveNewBillingAddress() {
      if (
          (this.newFirstName && this.newFirstName !== '') &&
          (this.newLastName && this.newLastName !== '') &&
          (this.newBillingAddress.line_1 && this.newBillingAddress.line_1 !== '') &&
          (this.newBillingAddress.town && this.newBillingAddress.town !== '') &&
          (this.newBillingAddress.postcode && this.newBillingAddress.postcode !== '') &&
          (this.selectedCountry && this.selectedCountry !== '')
      ) {
        return true;
      }
      return false;
    },

    isStillLoading() {
      if (this.klarnaInstalled && !this.klarnaClientToken) {
        return true;
      }

      if (!this.braintreeToken) {
        return true;
      }

      return false;
    }
  },

  methods: {
    ...mapActions([
      "retrieveBooking",
      "checkBookingIsComplete",
      "displayToastFromResponseObjectOfErrors",
      "setCustomerDetails",
      "setKlarnaSdkAsAvailable",
      "generateBillingTokens",
      "setPaymentMethod"
    ]),

    checkCanBeOnPage() {
      this.checkBookingIsComplete().then(() => {
        if (!this.selectedProblems.length) {
          return this.$router.push({name: 'repairSelect'})
        }

        if (this.inWarrantyStatus && !this.warrantyRepairChargeable) {
          this.$router.push({name: 'checkout'});
        } else if (!this.booking.date) {
          this.$router.push({name: 'repairDates'});
        } else if (!this.booking.email) {
          this.$router.push({name: 'customerDetails'});
        }
      });
    },

    saveNewBillingInformation() {
      if (!this.canSaveNewBillingAddress) return;
      this.billingAddressFormErrors = [];
      this.savingBillingAddress = true;

      this.setCustomerDetails({
        billing_first_name: this.newFirstName,
        billing_last_name: this.newLastName,
        billing_address: this.newBillingAddress,
        billing_country: this.selectedCountry.value 
      }).then(() => {
        this.billingAddress = "use-repair-address";
        this.billingAddressFormShown = false;
        this.generateBillingTokens().then(() => {
          this.savingBillingAddress = false;
        }).catch(() => {
          this.savingBillingAddress = false;
        });
      }).catch((errors) => {
        this.billingAddressFormErrors = errors.response.data.messages;
        this.savingBillingAddress = false;
      })
    },

    setManualBillingAddress() {
      this.billingAddressFormShown = true;
      this.$nextTick(() => {
        VueScrollTo.scrollTo("#billing-address-form", 250, {offset: -100})
      });

    },

    setupKlarna() {
      let self = this;
      let klarnaScript = document.createElement('script');

      klarnaScript.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js');

      document.head.appendChild(klarnaScript);
      window.klarnaAsyncCallback = function () {
        Klarna.Payments.init({
          client_token: self.klarnaClientToken
        });

        self.setKlarnaSdkAsAvailable();
      };
    },

    iwOrderIsOow() {
      return this.$bvModal.show("oow-modal");
    }
  }
}
</script>

<style>
.vs__dropdown-toggle {
  padding: 14px 10px;
}
</style>